import TableCell from '@mui/material/TableCell';
import { fontColorDarkTheme } from '../../../styles/global.styles';
import { Collapse } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { ReactNode } from 'react';

interface ExpandRowContentProps {
  isOpen: boolean;
  content: ReactNode;
}

const ExpandRowContent = ({ isOpen, content }: ExpandRowContentProps) => {
  return (
    <TableRow>
      <TableCell
        style={{
          border: '1px solid #2F3957FF',
          borderBottom: '1px solid #2F3957FF',
          color: fontColorDarkTheme,
        }}
        colSpan={6}
      >
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          {content}
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default ExpandRowContent;
